module.exports = __webpack_public_path__ + "images/photo-of-woman.png";